import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@material-ui/core";

import { parentContainer, webFont } from "../config/theme";
import Header from "../components/Header";
import { getSavedPosts, getSavedDishes, getSavedChefs } from "../redux/user";
import SavedChefs from "../components/Chefs/SavedChefs";
import SavedDishes from "../components/Dishes/SavedDishes";
import SavedPosts from "../components/Posts/SavedPosts";
import Footer from "../components/Footer/FooterLoggedIn";
import Breadcrumbs from "../components/Breadcrumbs";

class Home extends Component {
  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };

    const { dispatch, userId } = this.props;
    dispatch(getSavedPosts(userId));
    dispatch(getSavedDishes(userId));
    dispatch(getSavedChefs(userId));
  }

  render() {
    let noData = false;

    const { savedChefs, savedDishes, savedPosts } = this.props;

    if (
      savedChefs.length === 0 &&
      savedDishes.length === 0 &&
      savedPosts.length === 0
    ) {
      noData = true;
    }

    return (
      <div style={parentContainer}>
        <Grid container>
          <Grid item xs={12}>
            <Header history={this.props.history} />
          </Grid>

          <Grid item xs={12} className="saved-item-container">
            <Grid style={{ marginTop: 30 }}>
              <Breadcrumbs childRoutes={[
                {
                  display: 'Saved',
                  link: 'home/saved'
                },
              ]} />
            </Grid>
            <SavedChefs history={this.props.history} />
            <SavedDishes history={this.props.history} />
            <SavedPosts history={this.props.history} />
          </Grid>

          <Footer />
        </Grid>
      </div>
    );
  }
}

const mapStatetoProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    savedDishes: state.user.savedDishes,
    savedChefs: state.user.savedChefs,
    savedPosts: state.user.savedPosts
  };
};

const HomePage = connect(mapStatetoProps)(Home);

export default HomePage;

const styles = {
  setFont: {
    fontFamily: webFont
  }
};
